// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"fc157181","262":"430d9cc8","465":"7120aa16","473":"33f9f271","735":"2363b1e8","787":"87ff95f3","815":"2ef151b5","910":"238daf3d","968":"a6211405"}[chunkId] + ".chunk.js";
};